import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'se-fullscreen',
    templateUrl: './se-fullscreen.component.html',
    styleUrls: ['./se-fullscreen.component.css'],
})
export class SeFullScreenComponent {
    // events

    @Output()
    fullscreenChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    // data members

    @Input()
    enableFullscreenMode: boolean = true;

    private _fullscreen: boolean = false;
    get fullscreen() {
        return this._fullscreen;
    }
    @Input()
    set fullscreen(fullscreen) {
        if (this._fullscreen == fullscreen) {
            return;
        }

        this._fullscreen = fullscreen;
        this.fullscreenChange.emit(fullscreen);
    }

    // public functions

    onFullScreenToggle() {
        this.fullscreen = !this.fullscreen;
    }
}
